<template>
  <component
    :is="tagName"
    class="Heading"
    :class="[`Heading--${type}`, { 'Heading--visible': isVisible }]"
  >
    {{ heading }}
  </component>
</template>

<script>
export default {
  name: 'HeadingBase',
  props: {
    level: {
      type: String,
      required: true,
    },
    tag: {
      type: String,
      default: '',
    },
    heading: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      validator: function (value) {
        return (
          ['primary', 'secondary', 'tertiary', 'quaternary'].indexOf(value) !==
          -1
        );
      },
      default: 'primary',
    },
    isVisible: {
      type: Boolean,
    },
  },
  computed: {
    tagName() {
      return this.tag || `h${this.level}`;
    },
  },
};
</script>

<style lang="scss" scoped>
@use '@spectee/assets/scss/_forward.scss' as *;

.Heading {
  &--primary,
  &--secondary,
  &--tertiary,
  &--quaternary {
    font-weight: bold;
    line-height: $service-line-height-mp;
    color: $color-gray-80;
  }

  &--primary {
    font-size: $service-font-size-fff;
  }

  &--secondary {
    font-size: $service-font-size-ff;
  }

  &--tertiary {
    font-size: $service-font-size-f;
  }
  &--quaternary {
    font-size: $service-font-size-mf;
  }

  &--visible {
    @include hidden;
  }

  @media (max-width: 426px) {
    &--tertiary {
      font-size: $service-font-size-p;
    }
    &--quaternary {
      font-size: $service-font-size-mp;
    }
  }
}
</style>
